import { onlyAlphanumericAndSpaces } from "@/utils/reg-expressions";
import { z } from "zod";

export const roleFilterSchema = z.object({
  status: z.boolean().optional(),
  name: z.string().optional(),
});

export const roleCreationSchema = z.object({
  name: z
    .string()
    .nonempty({ message: "El campo es requerido." })
    .regex(onlyAlphanumericAndSpaces, {
      message: "No se aceptan caracteres especiales.",
    }),
  permissions: z.array(z.number()).optional(),
});
